<script setup lang="ts">
import { useTokenStore } from '@/stores/token'
import { useAppRouter } from '@/shared/composables/useAppRouter'
import { EPage } from '@/shared/enum/page.enum'
import SvgIcon from '@/components/common/SvgIcon.vue'
import { ESprites, ESpritesSocials } from '@/shared/enum/sprites.enum'

const icons = [
  { name: ESpritesSocials.FACEBOOK },
  { name: ESpritesSocials.INSTAGRAM },
  { name: ESpritesSocials.WHATSAPP },
  { name: ESpritesSocials.TWITTER },
  { name: ESpritesSocials.MESSENGER },
  { name: ESpritesSocials.WAZE }
]

const tokenStore = useTokenStore()
const { navigateToRoute } = useAppRouter()

const reditectToBuyPackages = () => {
  const routeName = tokenStore.decodedToken?.msisdn ? EPage.PACKAGES : EPage.TURN_ON_3G
  navigateToRoute(routeName)
}
</script>

<template>
  <button
    id="landing-buy-rechargine-btn"
    data-testid="qa_landing_buy_rechargine_btn"
    class="flex flex-col items-center justify-center gap-2 p-4 text-white align-middle rounded-lg shadow-md h-36 landing__button bg-teal-blue"
    itemprop="offers"
    itemscope
    itemtype="http://schema.org/Offer"
    @click="reditectToBuyPackages"
  >
    <p itemprop="name">
      <span class="block text-2xl">Comprar Superpacks</span>
      <span class="block">Recargas o Paquetes</span>
    </p>
    <span id="landing-icon-container" class="flex flex-row flex-wrap justify-center gap-2">
      <span v-for="icon in icons" :key="icon.name" class="bg-white rounded-full">
        <SvgIcon
          :file="ESprites.SOCIALS"
          :name="icon.name"
          width="24"
          height="24"
          class="text-grey-900"
        />
      </span>
    </span>
  </button>
</template>

<style scoped></style>
